<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">

    <!-- 卡片视图 -->
    <el-card style="padding:20px;">
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col>
          <el-button  class="add-column-btn bbox" style="color:#fff;" @click="addPoint(null)"  type="warning"> <i
              class="el-icon-plus fw900 f16"></i> 新增</el-button>
          
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-col :span="6" v-for="(item, index) in printerList" :key="index">
              <el-card class="point-card" shadow="hover">
                <div class="point-info">
                    <div class="point-name">{{ item.printName }}</div>
                    <div class="point-age">{{ item.printSize }}MM</div>
                    <div class="point-age">打印类型：{{ item.printType == 'bar'?"吧台":"厨房" }}</div>
                    <div class="point-age">网口：{{ item.ip }}</div>
                    <img class="pinterImg" src="../../assets/images/index/icon_print_type.jpg"></img>
                </div>
                <div class="point-operation">
                  <!-- <div class="point-ip">IP:{{item.ip}}</div> -->
                  <el-button class="buttonItem rightline line" type="text"  @click="deletePoint(item)">删除</el-button>
                  <el-button class="buttonItem line"  type="text"  @click="chooseGoods(item)">编辑</el-button>
                  <!-- <el-button class="buttonItem" type="text"   @click="chooseGoods(item)">选择菜品</el-button> -->
                </div>
              </el-card>
            </el-col>

            <!-- 列表为空时 -->
          </el-row>
        </el-scrollbar>
      </div>
    </el-card>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px" center>
      <el-form label-width="150px" :model="form" :rules="rules" ref="form" style="width: 100%;padding: 0 40px 0 80px;">
        <el-form-item label="打印机名称:" prop="printName" required :show-message="false">
          <el-input style="width: 220px" placeholder="" v-model="form.printName"></el-input>
        </el-form-item>
        <el-form-item label="IP地址:" prop="ip" required :show-message="false">
          <el-input style="width: 220px" placeholder="" v-model="form.ip" ></el-input>
        </el-form-item>
        <el-form-item label="端口号:" prop="port" required :show-message="false">
          <el-input  style="width:220px" v-model.number="form.port"></el-input>
          <!-- @keyup.native.enter="save" -->
        </el-form-item>
        <el-form-item label="打印尺寸:" prop="printSize" required :show-message="false">
          <el-input style="width: 220px" placeholder="" v-model="form.printSize" type="number"></el-input>
        </el-form-item>
        <el-form-item label="打印区域:" prop="merchantPrinterAreaList" required :show-message="false">
          <!-- <el-input style="width: 220px" placeholder="" v-model="form.merchantPrinterAreaListText" @focus="showDialog"></el-input> -->
          <el-select size="medium" style="width: 220px" value-key="areaClassCode" v-model="merchantPrinterAreaList" multiple placeholder="请选择">
    <el-option
      v-for="item in areaList"
      :key="item.areaClassCode" :label="item.areaClassName"
      :value="item">
    </el-option>
  </el-select>
          <!-- <el-select style="width: 220px" value-key="areaClassCode"  v-model="merchantPrinterAreaList" multiple placeholder="请选择">
            <el-option v-for="item in areaList" :key="item.areaClassCode" :label="item.areaClassName"
            :value="item">
            </el-option>
          </el-select> -->

        </el-form-item>
        <el-form-item label="打印机类型:" prop="printType" required :show-message="false">
          <!-- <el-input style="width: 220px" placeholder="" v-model="form.tableName"></el-input> -->
          <el-radio-group v-model="form.printType" >
            <el-radio label="bar">吧台</el-radio>
            <el-radio label="kitchen">厨房</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="一菜一单:" prop="isSingleDish" >
          <el-switch
            v-model="isSingleDish1"
            active-color="#FFBE00"
            inactive-color="#eee"
            :active-value="true"
            :inactive-value="false"
            @change="switchChange1">
          </el-switch>
        </el-form-item>
        <el-form-item label="分类一单:" prop="isSingleDish" >
          <el-switch
            v-model="isSingleDish2"
            active-color="#FFBE00"
            inactive-color="#eee"
            :active-value="true"
            :inactive-value="false"
            @change="switchChange2">
          </el-switch>
        </el-form-item>
        <el-form-item label="同时打印一份总单:" prop="isPrinterAll" >
          <el-switch
            v-model="form.isPrinterAll"
            active-color="#FFBE00"
            inactive-color="#eee"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSave">取 消</el-button>
        <el-button type="warning" @click="save" style="color:#fff;">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择桌台" :visible.sync="dialogVisible" width="800px">
      <div class="twoSide" v-loading="loading">
        <div class="left">
          <div @click="searchByCode(item)" :class="{ 'item': true, 'active': item.tableAreaCode == activeItem }"
            v-for="item, index in areaList" :key="index">{{ item.tableAreaName }}</div>
        </div>
        <div class="right">
          <div style="height:100%;">
            <el-table ref="tableRef" :row-key="getRowId" toggleRowSelection :data="tableData" border fit height="100%"
              highlight-current-row style="width: 100%" @sort-change="sortChange"
              @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
             
              <el-table-column label="桌台名称" align="center" prop="桌台名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.tableName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="标准用餐人数" align="center" prop="标准用餐人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.allowPeople }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数字助记码" align="center" prop="创建时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.openDt | dataFormat }}</span>
                </template>
              </el-table-column>
            </el-table>

            <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="queryInfo.currPage" :page-sizes="[10, 20, 30, 50]" :page-size="queryInfo.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination> -->
          </div>
        </div>
      </div>
      <div class="chooseList">
        <div class="chooseTop">
          <span style="fontWeight:bold;">已选择（{{this.merchantPrinterAreaList.length}}）</span>
          <el-button type="text" @click="clearAll">清空</el-button>
        </div>
        <div class="chooseLisTs">
          <div class="chooseItem" v-for="item,index in merchantPrinterAreaList">
            <span>{{item.areaClassName}}</span>
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelComfirm">取 消</el-button>
        <el-button type="warning" @click="confirm" style="color:#fff;">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading:true,
      printerList: [],
      dialogFormVisible:false,
      dialogVisible:false,
      title:'新增配置',
      form: {
        merchantName: localStorage.getItem('merchantName'),
        merchantCode: localStorage.getItem('merchantCode'),
        merchantPrinterAreaList:[],
        // merchantPrinterAreaListText:'',
        printName:'',
        ip:'',
        port:'',
        printSize:'',
        printType:'bar',
        isSingleDish:''
      },
      isSingleDish1:false,
      isSingleDish2:false,
      merchantPrinterAreaList: [],
      // value:'',
      rules: {
        
      },
       // 获取用户列表查询参数对象
       queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          merchantCode: localStorage.getItem("merchantCode")
        }
      },
      total:0,
      tableData:[],
      areaList:[],
      activeItem: '',
      height: window.innerHeight - 256, //表格高度

    };
  },
  created() {

    window.addEventListener('resize', this.getHeight)
  },
  mounted() {
    // this.loading = false;
    this.getAllPointerList()
    this.getArea()

  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {

    getAllPointerList(){
      this.loading = true;
      this.$http.post('/merchantPrinter/queryList', {merchantCode:localStorage.getItem("merchantCode")}).then(response => {
        console.log(response,'反餐');
        
        this.printerList = response.data.data;
        // this.total = response.data.total;
        this.loading = false;
      });
    },
    chooseGoods(item){
      const {printCode,id} = item
      console.log(item,'选择编辑');
         
      // return
      this.$router.push({
        path: "/foodManagement",
        query: { printCode,id },
      });
    },
    cancelSave(){
      this.dialogFormVisible = false

      this.form={
        merchantName: localStorage.getItem('merchantName'),
        merchantCode: localStorage.getItem('merchantCode'),
        merchantPrinterAreaList:[],
        // merchantPrinterAreaListText:'',
        printName:'',
        ip:'',
        port:'',
        printSize:'',
        printType:'bar',
        isSingleDish:''
      }
     this.isSingleDish1=false
      this.isSingleDish2=false
      this.merchantPrinterAreaList= []
    },

    // 新增编辑
    addPoint(item){
      this.$router.push({
        path:"/foodManagement",
        query:{id:null}
      })
      return
      if(item){
        const {id} = item
        this.$http.post('/merchantPrinter/queryPrintInfo', {id}).then(response => {
           if(response.data.code == 200){
            if(response.data.data.merchantPrinterAreaList.length !== 0){
              this.merchantPrinterAreaList = response.data.data.merchantPrinterAreaList
              // response.data.data.merchantPrinterAreaListText = response.data.data.merchantPrinterAreaList.map(item => item.areaClassName).toString();
            }
            if(response.data.data.isSingleDish == 1){
              this.isSingleDish1 = true
            }else{
              this.isSingleDish2 = true
            }
            this.form = response.data.data
           }
          });
      }else{
        
        this.form={
          merchantName: localStorage.getItem('merchantName'),
          merchantCode: localStorage.getItem('merchantCode'),
          merchantPrinterAreaList:[],
          // merchantPrinterAreaListText:'',
          printName:'',
          ip:'',
          port:'',
          printSize:'',
          printType:'bar',
          isSingleDish:''
        }
      this.isSingleDish1=false
        this.isSingleDish2=false
        this.merchantPrinterAreaList= []
      }
      this.dialogFormVisible = true
    },
    // 新增/保存打印机
    save(){
      if(!this.form.printName){
        this.$notify.error({
          title: '提示',
          message: '名称不能为空',
          showClose: true,
        });
        return
      }
      if(!this.form.ip){
        this.$notify.error({
          title: '提示',
          message: 'IP地址不能为空',
          showClose: true,
        });
        return
      }
      if(!this.form.port){
        this.$notify.error({
          title: '提示',
          message: '端口不能为空',
          showClose: true,
        });
        return
      }
      if(!this.form.printSize){
        this.$notify.error({
          title: '提示',
          message: '打印尺寸不能为空',
          showClose: true,
        });
        return
      }
      if(this.form.printType == 'bar'){
        if(this.merchantPrinterAreaList.length == 0){
        this.$notify.error({
          title: '提示',
          message: '请选择打印区域',
          showClose: true,
          });
          return
        }else{
          this.form.merchantPrinterAreaList = this.merchantPrinterAreaList
        }
      }else{
        this.form.merchantPrinterAreaList = this.merchantPrinterAreaList
      }
      if(this.isSingleDish1){
        this.form.isSingleDish = 1

      }
      if(this.isSingleDish2){
        this.form.isSingleDish = 2
      } 
          this.$http.post('/merchantPrinter/savePrinter', this.form).then(response => {
            this.$notify.success({
              title: '提示',
              message:this.form.id?'编辑成功' :'添加成功',
              showClose: true,
            });
            this.dialogFormVisible = false;
            this.cancelSave();
            this.getAllPointerList()
          });
    },
   async deletePoint(item){
      const {printCode} = item
      console.log(item,'删除对象');
      
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
        var that = this;
        // return
        that.$http.post("/merchantPrinter/deleteByPrintCode", { printCode,merchantCode: localStorage.getItem('merchantCode')}).then(function (response) {
          that.$notify.success({
            title: "提示",
            message: "删除成功",
            showClose: true,
          });
          that.getAllPointerList();
        });
      }
    },
    // 选择区域弹框
    showDialog(){
      this.dialogVisible = true
      this.loading = true;

      this.$nextTick( async ()=>{
        await this.getArea()
        await this.getListData()
        if(this.form.merchantPrinterAreaList.length !== 0){
          this.merchantPrinterAreaList = this.form.merchantPrinterAreaList
        }
      })
    },
     // 监听 pagesize改变的事件
     handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    getListData() {
      // 获取列表
      var that = this;
      that.$http
        .post("/merchantAreas/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
            that.loading = false;
          }
        });
    },
    searchByCode(item) {
      this.activeItem = item.tableAreaCode
      if (item.tableAreaCode != '') {
        this.queryInfo.condition.tableAreaCode = item.tableAreaCode
      } else {
        delete this.queryInfo.condition.tableAreaCode
      }
      this.tableArea1 = { tableAreaCode: item.tableAreaCode, tableAreaName: item.tableAreaName }
      this.getListData()
    },
      //获取桌台区域
      async getArea() {
      let res = await this.$http.post('merchantAreaClass/queryList', { merchantCode: localStorage.getItem('merchantCode') })
      this.areaList = res.data.data.map(item=>{
        item.areaClassCode = item.tableAreaCode;
        item.areaClassName = item.tableAreaName;
        return item
      })
      console.log(this.areaList, '-----')

      // this.areaList.unshift({ tableAreaCode: '', tableAreaName: '全部' })
      // this.tableArea1 = { tableAreaCode: '', tableAreaName: '全部' }
    },
     //多选
     handleSelectionChange(val) {
      // this.userSelected = val
      this.merchantPrinterAreaList = val.map(item=>{
        item.areaClassCode = item.tableAreaCode;
        item. areaClassName = item.tableAreaName;
        return item;
      })  
     
      console.log(this.merchantPrinterAreaListText,'选中');
      // let newArrary = [...this.merchantPrinterAreaList,...val]
      // let newArr = [];
      // let obj = {};
      // for (var i = 0; i < newArrary.length; i++) {
      //   if (!obj[newArrary[i].id]) {
      //     newArr.push(newArrary[i])
      //     obj[newArrary[i].id] = newArrary[i].id
      //   }
      // }
      //   this.merchantPrinterAreaList = newArr
      //   console.log(this.merchantPrinterAreaList,'去重数组');
    },
    switchChange1(e){
      console.log(e,'切换');
      console.log(this.form.isSingleDish,'-',this.isSingleDish1,'-',this.isSingleDish2);
      if(e){
        
        if(this.isSingleDish2){
          this.isSingleDish2 = false 
        }
      }
      
    },
    switchChange2(e){
      console.log(e,'切换');
      console.log(this.form.isSingleDish,'-',this.isSingleDish1,'-',this.isSingleDish2);
      if(e){
        
        if(this.isSingleDish1){
          this.isSingleDish1 = false 
        }
      }
      
    },
    // 监听排序
    sortChange() { },
      //唯一标识用于多选回显
    getRowId(row) {
      // console.log(row.id,'回显');
      return row.id
    },
    confirm(){
      this.form.merchantPrinterAreaListText = this.merchantPrinterAreaList.map(item=>{
        return item.tableName
      }).toString()
      this.dialogVisible = false;
    },
    cancelComfirm(){
      this.dialogVisible = false;
      this.merchantPrinterAreaList = []
    },
    clearAll(){
      this.merchantPrinterAreaList = []
      this.$refs.tableRef.clearSelection();
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #FFBE00;
    background: #FFBE00;
} 
/deep/ .el-radio__input.is-checked+.el-radio__label {
    color: #000;
}
/deep/ .el-card__body{
    padding: 0;
  }
.point-card{
  margin:10px;
  padding: 20px 0 0 0 ;

  .point-info{
    // display: flex;
    // justify-content: space-between;
    padding:20px;
    margin-bottom: 10px;
    position:relative;
    .point-name{
      font-size:20px;
      font-weight:bold;
    }
    .pinterImg{
      width: 100px;
      height: 100px;
      overflow: hidden;
      position:absolute;
      top:10px;
      right:10px;
    }
 
  }
  .point-operation{
    width:100%;
    display: flex;
    // justify-content: space-between;
    margin-top: 10px;
    align-items:center;
    border-top:1px solid #eee;
    .buttonItem{
      color:#409EFF;

      width:50%;
      margin-left:0px;
      border-bottom:none;
  padding:0;

    }
    .rightline{
      color:#f40;
    }

    .line{
      border-right:1px solid #eee;
    }
  }
}

.twoSide {
  display: flex;
  // align-items:center;
  margin-top: 20px;
  // height: calc(100% - 50px);
  height: 500px;

  .left {
    width: 140px;
    height: calc(100% - 50px);
    overflow: auto;
    padding-right: 14px;
    scroll-behavior: smooth;

    .item {
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: left;
      height: 32px;
      padding-left: 4px;
      width: 106px;
      margin-bottom: 6px;
      color: #666;
      font-size: 14px;
      cursor: pointer;
    }

    .active {
      background: #fff3Bf;
    }
  }

  .right {
    // margin-left: 12px;
    display: flex;
    flex: 1;
    // height: calc(100% - 50px);
    position: relative;

    .el-pagination {
      // position: absolute;
      // bottom: 0;
    }

    >div {
      width: 100%;
    }
  }
}

.chooseList{
  width: 100%;
  padding:10px 0;
  .chooseTop{
    display:flex;
    justify-content: space-between;
    align-items:center;
  }
  .chooseLisTs{
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    // justify-content: space-between;
    align-items: center;
   .chooseItem{
    padding:2px 6px;
    margin:0 10px;
    border:1px solid #ccc;
    border-radius:6px;
   }
  }
}

/deep/ .el-dialog__body{
  padding:20px
}

/deep/ .el-table.el-table--border {
  margin-top: 0;
}

/deep/ .el-card {
  // height: calc(100vh - 79px);
  // background: red;
}

/deep/ .el-card__body {
  // height: 100%;
  box-sizing: border-box;
}

/deep/ .el-button {
  // background: #f59a23;
  color: #000;
  border-color: none;
  border:none;

}



// /deep/ .el-button:hover {
//   background: #f59a23;
//   color: #fff;
//   border-color: #f59a23;
// }
</style>
